import { render, staticRenderFns } from "./shikho_junior.vue?vue&type=template&id=2c90d71a&"
import script from "./shikho_junior.vue?vue&type=script&lang=js&"
export * from "./shikho_junior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports